import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Gérer les transporteurs", -1)
const _hoisted_2 = { class: "flex justify-end ml-auto" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { class: "flex justify-end w-full mt-4" }
const _hoisted_8 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_9 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_10 = { class: "d-flex flex-row" }

import DataTable from "primevue/datatable";
import { onMounted, ref } from "vue";
import { ITransporterList } from "@/models/transporter/ITransporterList";
import {
  fetchTransporter,
  triggerTransporterState,
  deleteTransporter,
} from "@/_services/transporter/transporter";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Column from "primevue/column";
import InputSwitch from "primevue/inputswitch";
import swal from "@/_helpers/swal";
import TransporterFormModal from "@/components/modal/transporter/TransporterFormModal.vue";
import router from "@/router";

const transporterFormModalId = "supplierFormModal";

export default /*#__PURE__*/_defineComponent({
  __name: 'TransporterList',
  setup(__props) {

const transporter = Array<ITransporterList>();
const tableData = ref<Array<ITransporterList>>(transporter);
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const totalRecords = ref<number>(0);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const page = ref<number>(1);
const modeSortable = ref<boolean>(false);
const defaultsSort = {
  fieldLabel: "order[createdAt]",
  fieldValue: "desc",
};
const transporterUuid = ref<string>("");

onMounted(async () => {
  await populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
  const [loadingDt, totalRecordsDt, tableDataDt] = await fetchTransporter(
    itemsPerPage,
    page,
    criteria,
    sort
  );
  totalRecords.value = totalRecordsDt.value;
  tableData.value = tableDataDt.value;
  isLoading.value = loadingDt.value;
};

async function onPaginate(e) {
  rows.value = e.rows;
  populateDatatable(e.rows, e.page + 1, criteria.value, defaultsSort);
}

const onSort = (e) => {
  if (e.sortField) {
    const sort = {
      fieldLabel: "order[" + e.sortField + "]",
      fieldValue: e.sortOrder === 1 ? "asc" : "desc",
    };
    modeSortable.value = true;
    populateDatatable(rows.value, page.value, criteria.value, sort);
  } else {
    modeSortable.value = false;
    populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
  }
};

const onFilterDt = () => {
    if (criteria.value.trim() != "") {
    populateDatatable(rows.value, page.value, criteria.value.trim(), defaultsSort);
  }
};

const onClearInputFilter = () => {
  if (criteria.value.trim() == "") {
    populateDatatable(rows.value, page.value,"", defaultsSort);
  }
};

const onDelete = (data: ITransporterList) => {
  swal
    .confirm("Êtes vous sur de vouloir archiver le transporteur ?")
    .then((result) => {
      if (result.isConfirmed) {
        deleteTransporter(data.uuid).then(() => {
          swal.success("Archivé !", "Vous venez d'archiver un transporteur");
          refreshDatatable();
        });
      }
    });
};

const changeState = async (uuid: string, isActive: boolean) => {
  let currentStateBeforeSave = !isActive;
  const confirmationMessage = currentStateBeforeSave
    ? "Êtes-vous sûr de vouloir désactiver le transporteur ?"
    : "Êtes-vous sûr de vouloir activer le transporteur ?";

  const result = await swal.confirm(confirmationMessage);

  if (result.isConfirmed) {
    await triggerTransporterState(uuid, isActive);
    const successMessage = isActive
      ? "Vous venez d'activer un transporteur."
      : "Vous venez de désactiver un transporteur.";

    swal.success("Opération réussie !", successMessage);
    refreshDatatable();
    //relaodPage();
  }
};
const setUuidAndOpenModal = (uuid: string) => {
  transporterUuid.value = uuid;
  const transporterFormModalElement:HTMLDialogElement | null = document.querySelector(`#${transporterFormModalId}`);
  if (transporterFormModalElement) {
    transporterFormModalElement.showModal();
  }
};

const refreshDatatable = () => {
  console.dir("IS EMIT")
  populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
};

const relaodPage = () => {
    window.location.reload();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        label: "Ajouter un transporteur",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (setUuidAndOpenModal(''))),
        icon: "pi pi-plus",
        "aria-label": "Ajouter un transporteur",
        class: "button-add mb-2"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        value: tableData.value,
        paginator: true,
        rows: rows.value,
        removableSort: "",
        loading: isLoading.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: [10, 25, 100],
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
        onPage: _cache[2] || (_cache[2] = ($event: any) => (onPaginate($event))),
        onSort: _cache[3] || (_cache[3] = ($event: any) => (onSort($event)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_unref(InputText), {
                type: "text",
                modelValue: criteria.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria).value = $event)),
                placeholder: "Recherche par transporteur",
                onKeyup: _withKeys(onFilterDt, ["enter"]),
                onInput: onClearInputFilter
              }, null, 8, ["modelValue", "onKeyup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, " Nombre total de transporteurs : " + _toDisplayString(totalRecords.value), 1)
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun transporteur ne correspond à votre recherche")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(Column), {
              field: "name",
              header: "Nom du transporteur"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "isActive",
              header: "Etat",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.isActive)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Actif "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, " Inactif "))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "createdAt",
              header: "Date de création",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.createdAt), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "action",
              header: "Action"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-pencil",
                    class: "p-edition",
                    style: {"margin-right":"0.5em"},
                    title: "Éditer",
                    onClick: ($event: any) => (setUuidAndOpenModal(slotProps.data.uuid))
                  }, null, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-trash",
                    class: "p-button-danger",
                    style: {"margin-right":"0.5em"},
                    title: "Éditer",
                    onClick: ($event: any) => (onDelete(slotProps.data))
                  }, null, 8, ["onClick"]),
                  _createVNode(_unref(InputSwitch), {
                    modelValue: slotProps.data.isActive,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.isActive) = $event),
                    "input-id": slotProps.data.uuid,
                    onInput: ($event: any) => (changeState(slotProps.data.uuid, slotProps.data.isActive))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "input-id", "onInput"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "totalRecords", "currentPage"]),
      _createVNode(TransporterFormModal, {
        "transporter-uuid": transporterUuid.value,
        "transporter-form-modal-id": transporterFormModalId,
        onTransporterCreated: relaodPage,
        onTransporterUpdated: relaodPage
      }, null, 8, ["transporter-uuid"])
    ])
  ], 64))
}
}

})